import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from "../hooks";
import { addTransaction, TransactionType } from "./actions";
import { useWeb3React } from '@web3-react/core';
export var useAllTransactions = function useAllTransactions() {
  var _useWeb3React = useWeb3React(),
      chainId = _useWeb3React.chainId;

  return useAppSelector(function (state) {
    return state.transactions[chainId] || {};
  });
};
export var useTransaction = function useTransaction(txHash) {
  var allTransactions = useAllTransactions();
  if (!txHash) return undefined;
  return allTransactions[txHash];
};
export var useTransactionIsPending = function useTransactionIsPending(txHash) {
  var allTransactions = useAllTransactions();
  if (!txHash || !allTransactions[txHash]) return undefined;
  return !allTransactions[txHash].receipt;
};
export var useTransactionIsConfirmed = function useTransactionIsConfirmed(txHash) {
  var allTransactions = useAllTransactions();
  if (!txHash || !allTransactions[txHash]) return undefined;
  return Boolean(allTransactions[txHash].receipt);
};
export var useHasPendingApproval = function useHasPendingApproval(tokenAddress, spender) {
  var allTransactions = useAllTransactions();
  return useMemo(function () {
    return typeof tokenAddress === 'string' && typeof spender === 'string' && Object.values(allTransactions).some(function (tx) {
      if (tx.receipt) return false;
      if (tx.info.type !== TransactionType.APPROVAL) return false;
      return tx.info.tokenAddress === tokenAddress && tx.info.spender === spender;
    });
  }, [allTransactions, tokenAddress, spender]);
};
export var useTransactionAdder = function useTransactionAdder() {
  var _useWeb3React2 = useWeb3React(),
      chainId = _useWeb3React2.chainId,
      account = _useWeb3React2.account;

  var dispatch = useAppDispatch();
  return useCallback(function (response, info) {
    if (!account || !chainId) return;
    var hash = response.hash;
    if (!hash) throw new Error('No transaction hash found.');
    dispatch(addTransaction({
      hash: hash,
      from: account,
      info: info,
      chainId: chainId
    }));
  }, [chainId, account, dispatch]);
};